// src/utils/citationParser.js

export class CitationParser {
  // Regex to match citation tags in AI responses
  static CITATION_REGEX = /<(?:citation|cipitation)\s+filename=['"]([^'"]+)['"]\s+page_number=['"](\d+)['"]>([^<]+)<\/(?:citation|cipitation)>/gi;

  static parseCitations(text) {
    const citations = [];
    
    if (!text) return citations;
    
    let match;
    while ((match = this.CITATION_REGEX.exec(text)) !== null) {
      citations.push({
        fullMatch: match[0],
        filename: match[1],
        pageNumber: parseInt(match[2]),
        quote: match[3].trim()
      });
    }
    
    return citations;
  }

  static removeCitationTags(text) {
    if (!text) return '';
    return text.replace(this.CITATION_REGEX, '$3');
  }

  static convertToCitations(citationMatches) {
    return citationMatches.map(match => ({
      documentId: match.filename.replace(/\.[^/.]+$/, ""), // Remove extension for ID
      filename: match.filename,
      pageNumber: match.pageNumber,
      quote: match.quote,
      fullMatch: match.fullMatch,
      confidence: 1.0 // Default confidence
    }));
  }
}
